import { findKey } from "lodash";
import { usePage } from "PFApp/use_page";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import useWorkflowPermissions from "./parts/use_workflow_permissions";

const useWorkflowPage = (initPage) => {
  const history = useHistory();

  const { isEngagementEnabled, isRoleEnabled, isPlannerEnabled } = useWorkflowPermissions();
  const { page, setPage, resetPage } = usePage(`workflowPage`, initPage);

  const [tab, setTab] = useState(
    initPage.tab || window.storage.getItem("previous_workflow_section") || "roles"
  );

  useEffect(() => {
    const viewsPermissions = {
      engagements: isEngagementEnabled,
      roles: isRoleEnabled,
      planner: isPlannerEnabled
    };

    if (!viewsPermissions[tab]) {
      const newTab = findKey(viewsPermissions, (permission) => permission);
      if (newTab) {
        changeTab(newTab);
      } else {
        history.push("/");
      }
    }
  }, []);

  const changeTab = (newTab) => {
    history.push(`/workflow/${newTab}`);
    window.storage.setItem("previous_workflow_section", newTab);
    setTab(newTab);
  };

  useEffect(() => {
    setPage({
      ...initPage,
      tab,
      changeTab,
      isEngagementEnabled,
      isRoleEnabled,
      isPlannerEnabled,
      initialized: true
    });
    return resetPage;
  }, [tab]);

  return page;
};

export default useWorkflowPage;
